(() => {
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(Number(cents) / 100); }
    catch (_) { return `€${(Number(cents) / 100).toFixed(2).replace('.', ',')}`; }
  };
  const track = (event, label = '') => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, vc_label: label });
    document.dispatchEvent(new CustomEvent('vc:commerce', { detail: { event, label } }));
  };

  async function addVariantToCart(variantId, trackingEvent, trackingLabel) {
    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer ? cartDrawer.getSectionsToRender().map(section => section.id) : ['cart-icon-bubble'];
    const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections, sections_url: window.location.pathname })
    });
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || 'Cart error');
    if (trackingEvent) track(trackingEvent, trackingLabel || '');
    if (cartDrawer && state.sections) cartDrawer.renderContents(state);
    else window.location.reload();
  }

  const initStickyAtc = () => {
    const sticky = document.querySelector('[data-vc-sticky-atc]');
    if (!sticky) return;
    const sectionId = sticky.dataset.sectionId;
    const info = document.getElementById(`ProductInfo-${sectionId}`);
    if (!info) return;
    const getMainButton = () => info.querySelector('.product-form__submit[name="add"]');
    const stickyButton = sticky.querySelector('[data-vc-sticky-button]');
    const stickyPrice = sticky.querySelector('[data-vc-sticky-price]');
    let buttonObserver;
    let observedButton;

    const sync = () => {
      const mainButton = getMainButton();
      if (!mainButton) return;
      stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.textContent = mainButton.querySelector('span')?.textContent?.trim() || stickyButton.dataset.defaultLabel;
      const priceBox = document.getElementById(`price-${sectionId}`);
      if (priceBox && stickyPrice) {
        const sale = priceBox.querySelector('.price--on-sale .price-item--sale');
        const regular = priceBox.querySelector('.price__regular .price-item--regular');
        const value = (sale || regular)?.textContent?.trim();
        if (value) stickyPrice.textContent = value;
      }
    };

    const observeButton = () => {
      const mainButton = getMainButton();
      if (!mainButton || mainButton === observedButton) return;
      observedButton = mainButton;
      buttonObserver?.disconnect();
      buttonObserver = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 240);
      }, { threshold: .08 });
      buttonObserver.observe(mainButton);
    };

    stickyButton.addEventListener('click', () => {
      const mainButton = getMainButton();
      if (!mainButton || mainButton.disabled) return;
      track('sticky_add_to_cart_click', location.pathname);
      mainButton.click();
    });
    new MutationObserver(() => { sync(); observeButton(); }).observe(info, { childList: true, subtree: true, attributes: true });
    sync(); observeButton();
  };

  class VCCartUpsells extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';
      this.load();
    }
    async load() {
      try {
        const response = await fetch(this.dataset.url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(response.status);
        const data = await response.json();
        const inCart = new Set((this.dataset.cartProductIds || '').split(',').filter(Boolean).map(String));
        const products = (data.products || []).filter(p => p.available && !inCart.has(String(p.id))).slice(0, 2);
        if (!products.length) return this.remove();
        this.innerHTML = `<div class="vc-cart-upsells"><div class="vc-cart-upsells__head"><strong>${escapeHtml(this.dataset.heading || '')}</strong><span>${escapeHtml(this.dataset.sub || '')}</span></div><div class="vc-cart-upsells__list">${products.map(product => this.card(product)).join('')}</div></div>`;
      } catch (_) { this.remove(); }
    }
    card(product) {
      const variant = (product.variants || []).find(v => v.available) || product.variants?.[0];
      const direct = variant && (product.variants || []).length === 1;
      const image = product.featured_image || product.images?.[0] || '';
      const titleRaw = product.title || '';
      const title = escapeHtml(titleRaw.length > 52 ? `${titleRaw.slice(0, 51)}…` : titleRaw);
      const action = direct
        ? `<button type="button" class="vc-cart-upsell__add" data-vc-upsell-add data-variant-id="${variant.id}" data-vc-label="${escapeHtml(product.handle || '')}" aria-label="${escapeHtml(this.dataset.addLabel || 'Add')}: ${title}">+</button>`
        : `<a href="${product.url}" class="vc-cart-upsell__add" aria-label="${title}">→</a>`;
      return `<div class="vc-cart-upsell__item"><a href="${product.url}" class="vc-cart-upsell__image">${image ? `<img src="${image}" alt="" loading="lazy">` : ''}</a><div class="vc-cart-upsell__info"><a href="${product.url}" class="vc-cart-upsell__title">${title}</a><span class="vc-cart-upsell__price">${money(variant?.price ?? product.price ?? 0)}</span></div>${action}</div>`;
    }
  }
  if (!customElements.get('vc-cart-upsells')) customElements.define('vc-cart-upsells', VCCartUpsells);

  document.addEventListener('click', async (event) => {
    const upsell = event.target.closest('[data-vc-upsell-add]');
    const complementary = event.target.closest('[data-vc-complementary-add]');
    const btn = upsell || complementary;
    if (!btn) return;
    event.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.disabled = true;
    try {
      await addVariantToCart(btn.dataset.variantId, upsell ? 'cart_upsell_added' : 'pdp_complementary_added', btn.dataset.vcLabel || '');
    } catch (_) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  });

  const initReviewJump = () => {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vc-review-jump]');
      if (!trigger) return;
      const target = document.querySelector('.jdgm-rev-widg, [data-oke-widget], .spr-container, .loox-reviews-default, #shopify-product-reviews, .shopify-app-block');
      if (target) {
        track('review_jump_click', location.pathname);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  };

  const initSearchDiscovery = () => {
    document.querySelectorAll('.search-modal__form').forEach((root) => {
      const input = root.querySelector('input[type="search"]');
      const discovery = root.querySelector('[data-vc-search-discovery]');
      if (!input || !discovery) return;
      const sync = () => discovery.hidden = input.value.trim().length > 0;
      input.addEventListener('input', sync);
      input.addEventListener('focus', sync);
      sync();
    });
  };

  const initRecentlyViewed = () => {
    const key = 'vc_recent_products_v1';
    let items = [];
    try { items = JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) {}
    const currentScript = document.querySelector('[data-vc-current-product]');
    let current = null;
    if (currentScript) { try { current = JSON.parse(currentScript.textContent); } catch (_) {} }
    const displayItems = items.filter(p => !current || String(p.id) !== String(current.id)).slice(0, 4);
    document.querySelectorAll('[data-vc-recently-viewed]').forEach((section) => {
      const grid = section.querySelector('[data-vc-recent-grid]');
      if (!grid || !displayItems.length) return;
      grid.innerHTML = displayItems.map(p => `<a class="vc-recent-card" href="${p.url}"><span class="vc-recent-card__image">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}</span><span class="vc-recent-card__title">${escapeHtml(p.title)}</span><span class="vc-recent-card__price">${escapeHtml(p.price)}</span></a>`).join('');
      section.hidden = false;
    });
    if (current) {
      items = [current, ...items.filter(p => String(p.id) !== String(current.id))].slice(0, 8);
      try { localStorage.setItem(key, JSON.stringify(items)); } catch (_) {}
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    initStickyAtc();
    initReviewJump();
    initSearchDiscovery();
    initRecentlyViewed();
  });
})();
